"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AudioCreationPropertiesToJSON = exports.AudioCreationPropertiesFromJSONTyped = exports.AudioCreationPropertiesFromJSON = exports.instanceOfAudioCreationProperties = void 0;
var runtime_1 = require("../runtime");
var AudioCreationStatus_1 = require("./AudioCreationStatus");
var MixProperties_1 = require("./MixProperties");
var ScriptProperties_1 = require("./ScriptProperties");
var VoiceoverProperties_1 = require("./VoiceoverProperties");
/**
 * Check if a given object implements the AudioCreationProperties interface.
 */
function instanceOfAudioCreationProperties(value) {
    var isInstance = true;
    isInstance = isInstance && "voiceoverProperties" in value;
    return isInstance;
}
exports.instanceOfAudioCreationProperties = instanceOfAudioCreationProperties;
function AudioCreationPropertiesFromJSON(json) {
    return AudioCreationPropertiesFromJSONTyped(json, false);
}
exports.AudioCreationPropertiesFromJSON = AudioCreationPropertiesFromJSON;
function AudioCreationPropertiesFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'status': !(0, runtime_1.exists)(json, 'status') ? undefined : (0, AudioCreationStatus_1.AudioCreationStatusFromJSON)(json['status']),
        'voiceoverPreviewId': !(0, runtime_1.exists)(json, 'voiceover_preview_id') ? undefined : json['voiceover_preview_id'],
        'mixPreviewId': !(0, runtime_1.exists)(json, 'mix_preview_id') ? undefined : json['mix_preview_id'],
        'generatedScriptId': !(0, runtime_1.exists)(json, 'generated_script_id') ? undefined : json['generated_script_id'],
        'toneAndFeel': !(0, runtime_1.exists)(json, 'tone_and_feel') ? undefined : json['tone_and_feel'],
        'toneAndFeelFreetext': !(0, runtime_1.exists)(json, 'tone_and_feel_freetext') ? undefined : json['tone_and_feel_freetext'],
        'brandName': !(0, runtime_1.exists)(json, 'brand_name') ? undefined : json['brand_name'],
        'adCategories': !(0, runtime_1.exists)(json, 'ad_categories') ? undefined : json['ad_categories'],
        'scriptProperties': !(0, runtime_1.exists)(json, 'script_properties') ? undefined : (0, ScriptProperties_1.ScriptPropertiesFromJSON)(json['script_properties']),
        'voiceoverProperties': (0, VoiceoverProperties_1.VoiceoverPropertiesFromJSON)(json['voiceover_properties']),
        'mixProperties': !(0, runtime_1.exists)(json, 'mix_properties') ? undefined : (0, MixProperties_1.MixPropertiesFromJSON)(json['mix_properties']),
    };
}
exports.AudioCreationPropertiesFromJSONTyped = AudioCreationPropertiesFromJSONTyped;
function AudioCreationPropertiesToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'status': (0, AudioCreationStatus_1.AudioCreationStatusToJSON)(value.status),
        'voiceover_preview_id': value.voiceoverPreviewId,
        'mix_preview_id': value.mixPreviewId,
        'generated_script_id': value.generatedScriptId,
        'tone_and_feel': value.toneAndFeel,
        'tone_and_feel_freetext': value.toneAndFeelFreetext,
        'brand_name': value.brandName,
        'ad_categories': value.adCategories,
        'script_properties': (0, ScriptProperties_1.ScriptPropertiesToJSON)(value.scriptProperties),
        'voiceover_properties': (0, VoiceoverProperties_1.VoiceoverPropertiesToJSON)(value.voiceoverProperties),
        'mix_properties': (0, MixProperties_1.MixPropertiesToJSON)(value.mixProperties),
    };
}
exports.AudioCreationPropertiesToJSON = AudioCreationPropertiesToJSON;
